<template>
  <div class="font-sans">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
import 'primeicons/primeicons.css';

//Import Mixpanel SDK
import mixpanel from 'mixpanel-browser';

// Create an instance of the Mixpanel object, your token is already added to this snippet
mixpanel.init('696960b1f49ed0ba0b2e513c43c756db', {
  autocapture: true,
  record_sessions_percent: 100,
});

const authStore = useAuthStore();

// Initialize auth on app start or write middleware/auth.global.ts for more control over routing.
onMounted(async () => {
  await authStore.initialize();
  if (authStore.user) {
    mixpanel.identify(authStore.user.id);
    mixpanel.people.set({
      $name: authStore.user.name,
      $email: authStore.user.email,
    });
  }
});
</script>

<style>
html {
  color-scheme: light !important;
}

a {
  color: var(--p-primary-color);
}

/* :root body {
  --p-button-primary-background: #ff0000;
} */
:root body {
  --p-tabs-tab-padding: 15px;
}
</style>
